import { css, cx } from '@emotion/css';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { RootState } from 'store/store';
import { colors } from 'styles/colors';

const Background = () => {
    const location = useLocation();

    const participantViewState = useSelector((state: RootState) => state.user.participantViewState);
    const isLoading = useSelector((state: RootState) => state.global.isLoading);

    return (
        <>
            {location.pathname === '/' && <div className={styles.timeLineBackground}></div>}

            {participantViewState === 'Access to DashBoard 1' && ['/time-line'].includes(location.pathname) && (
                <div className={cx(styles.timeLineBackground, isLoading && styles.loadingBackground)}></div>
            )}

            {participantViewState === 'Access to DashBoard 1' && ['/questionnaries-list', '/fooddiary'].includes(location.pathname) && (
                <div className={cx(styles.questionnariesBackground, isLoading && styles.loadingBackground)}></div>
            )}

            {location.pathname === '/questionnaire' && <div className={styles.screeningAndGameBackground}></div>}
        </>
    );
};

const styles = {
    loadingBackground: css({
        background: colors.backgroundLoading,
    }),
    timeLineBackground: css({
        background: colors.background,
        width: '100%',
        position: 'fixed',
        height: '100%',
    }),
    questionnariesBackground: css({
        background: colors.background,
        width: '100%',
        position: 'fixed',
        height: '100%',
        zIndex: '-9',
    }),
    screeningAndGameBackground: css({
        background: colors.backgroundLight,
        width: '100%',
        position: 'fixed',
        height: '100%',
        zIndex: '-9999',
    }),
};

export default Background;
